// Unassigned Site List Action Types
export const FETCH_UNASSIGNED_SITE_LIST_REQUEST = 'FETCH_UNASSIGNED_SITE_LIST_REQUEST';
export const FETCH_UNASSIGNED_SITE_LIST_SUCCESS = 'FETCH_UNASSIGNED_SITE_LIST_SUCCESS';
export const FETCH_UNASSIGNED_SITE_LIST_FAILURE = 'FETCH_UNASSIGNED_SITE_LIST_FAILURE';

// Practice Dropdown Action Types  
export const FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST = 'FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST';
export const FETCH_UNASSIGNED_PRACTICE_DROPDOWN_SUCCESS = 'FETCH_UNASSIGNED_PRACTICE_DROPDOWN_SUCCESS';
export const FETCH_UNASSIGNED_PRACTICE_DROPDOWN_FAILURE = 'FETCH_UNASSIGNED_PRACTICE_DROPDOWN_FAILURE';

// Sub Practice Dropdown Action Types
export const FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_REQUEST = 'FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_REQUEST';
export const FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_SUCCESS = 'FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_SUCCESS';
export const FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_FAILURE = 'FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_FAILURE';

// Save Bulk Practice Site Action Types
export const SAVE_UNASSIGNED_BULK_PRACTICE_SITE_REQUEST = 'SAVE_UNASSIGNED_BULK_PRACTICE_SITE_REQUEST';
export const SAVE_UNASSIGNED_BULK_PRACTICE_SITE_SUCCESS = 'SAVE_UNASSIGNED_BULK_PRACTICE_SITE_SUCCESS';
export const SAVE_UNASSIGNED_BULK_PRACTICE_SITE_FAILURE = 'SAVE_UNASSIGNED_BULK_PRACTICE_SITE_FAILURE';

// Region/National by Practice Action Types
export const FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_REQUEST = 'FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_REQUEST';
export const FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_SUCCESS = 'FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_SUCCESS';
export const FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_FAILURE = 'FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_FAILURE';